<p-confirm-dialog [draggable]="false" />
<mon-page-layout
    [header]="'adminScanExclusions.page.header' | transloco"
    [subheader]="'adminScanExclusions.page.subHeader' | transloco">
    <p-tabs
        [value]="activeModule"
        (valueChange)="onTabChange($event)"
        data-test="admin-scanExclusions-tabs"
        class="tw-mb-4">
        <p-tablist data-test="admin-scanExclusions-tabs-list">
            @for (module of modules; track module.value) {
                <p-tab [value]="module.value">{{ module.name | transloco }}</p-tab>
            }
        </p-tablist>
    </p-tabs>
    <mon-table-wrapper [value]="scanExclusions"
                       [headers]="[
                           TABLE_SCHEMA.NAME,
                           TABLE_SCHEMA.ACTIONS
                       ]"
                       [total]="total"
                       [currentPage]="page"
                       [perPage]="pageSize"
                       [loading]="loading"
                       [fixedTableLayout]="false"
                       [emptyMessage]="'adminScanExclusions.table.emptyMessage' | transloco"
                       (page)="onPageChange($event)"
                       tableKey="admin-scanExclusions">
        <ng-container monTableRight>
            <p-button data-test="admin-scanExclusions-add-button"
                      [label]="'adminScanExclusions.page.addButtonLabel' | transloco"
                      icon="pi pi-plus"
                      (onClick)="addScanExclusion()"
            />
        </ng-container>
        <span monTableCaption>{{ 'adminScanExclusions.table.description' | transloco }}</span>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.ACTIONS; let scanExclusion">
            <p-button
                    [ariaLabel]="'adminScanExclusions.table.actionMenuBtnAriaLabel{{scanExclusionName}}' | transloco: { scanExclusionName: scanExclusion.name }"
                    data-test="admin-scanExclusion-actions-button"
                    icon="pi pi-ellipsis-v"
                    [rounded]="true"
                    [text]="true"
                    (onClick)="menu.toggle($event)" />
            <p-menu
                    data-test="admin-scanExclusion-actions-menu"
                    appendTo="body"
                    #menu
                    [model]="scanExclusion.actionItems"
                    [popup]="true"
                    (onHide)="onMenuHide()"
            >
            </p-menu>
        </ng-container>
    </mon-table-wrapper>
</mon-page-layout>
